module.exports = __webpack_public_path__ + "static/media/bullseye-pointer.c7d3bb0a.svg";